export default __webpack_public_path__ + "static/media/bulk-order.a52896c7.wav";